import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Tip = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Tip' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M16.0073529,18 L22,18 L22,2 L2,2 L2,18 L8.24264706,18 L12.125,22 L16.0073529,18 Z' />
  </StyledIcon>
);
